/**
 * OcorrenciaTracking
 * @author hugohiga
 */
import {$, HttpBody, ID, Resource, ResponseSerialize, TAG} from 'simpli-web-sdk'
import {
  ValidationMaxLength,
  ValidationRequired,
} from 'simpli-web-sdk'
import OcorrenciaTrackingSchema from '@/schema/OcorrenciaTracking.schema'
import Responsavel from '@/model/resource/Responsavel'

export default class OcorrenciaTracking extends Resource {
  get $schema() {
    return OcorrenciaTrackingSchema(this)
  }

  get $id() {
    return this.idOcorrenciaTrackingResponsavelPk
  }
  set $id(val: ID) {
    this.idOcorrenciaTrackingResponsavelPk = val
  }
  get $tag() {
    return this.descricao
  }
  set $tag(val: TAG) {
    this.descricao = val
  }

  static async persistLoteOcorrenciaTracking(listToPersist: OcorrenciaTracking[],
                                             spinner = 'persistLoteOcorrenciaTracking') {
    const fetch = async () => {
      return await new HttpBody(Number).POST(`/user/lote-ocorrencia-tracking`, listToPersist)
    }

    return await $.await.run(fetch, spinner)
  }

  readonly $name: string = 'OcorrenciaTracking'

  readonly $endpoint: string = '/user/ocorrencia-tracking{/id}'

  @ResponseSerialize(Responsavel)
  responsavel: Responsavel | null = null

  idOcorrenciaTrackingResponsavelPk: ID = 0

  idOcorrenciaExterna: number | null = null

  @ValidationRequired()
  @ValidationMaxLength(100)
  descricao: string = ''

  @ValidationRequired()
  ativo: boolean = false

  async persistOcorrenciaTracking(spinner = 'persistOcorrenciaTracking') {
    const fetch = async () => {
      await this.validate()
      return await this.POST(`/user/ocorrencia-tracking`, this)
    }

    return await $.await.run(fetch, spinner)
  }

  async getOcorrenciaTracking(id: ID, spinner = 'getOcorrenciaTracking') {
    const fetch = async () => await this.GET(`/user/ocorrencia-tracking/${id}`)
    return await $.await.run(fetch, spinner)
  }

  async removeOcorrenciaTracking(id: number, spinner = 'removeOcorrenciaTracking') {
    const fetch = async () => await this.DELETE(`/user/ocorrencia-tracking/${id}`)
    return await $.await.run(fetch, spinner)
  }
}
